import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CInput from '@/components/shared/CInput';
import CButton from '@/components/shared/CButton';
import CalendarColorField from './CalendarColorField.vue';
import CalendarFieldTitle from './CalendarFieldTitle.vue';
import type { CalendarStrokeValue } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarStrokeField',
  props: {
    width: { default: '0' },
    color: { default: '#000000' },
    title: { default: 'Stroke' },
    disabled: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'update', value: CalendarStrokeValue): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { width: string, color: string, title: string, disabled?: boolean };

const DEFAULT_STROKE: CalendarStrokeValue = { width: '0.5', color: '#000000' };





// Not derived from width so typing 0 doesn't collapse the fields; parent remounts on element change
const enabled = ref(Number(props.width) > 0);

const isTransparent = (color: string) => color === 'transparent' || /^#[0-9a-f]{6}00$/i.test(color);

const toggle = () => {
    enabled.value = !enabled.value;
    if (enabled.value) {
        emit('update', {
            width: DEFAULT_STROKE.width,
            color: isTransparent(props.color) ? DEFAULT_STROKE.color : props.color
        });
    } else {
        emit('update', { width: '0', color: props.color });
    }
};

const onWidthChange = (value: string | number = 0) => {
    emit('update', { width: String(value), color: props.color });
};

const onColorChange = (color: string) => {
    emit('update', { width: props.width, color });
};

return { __sfc: true,DEFAULT_STROKE, props, emit, enabled, isTransparent, toggle, onWidthChange, onColorChange, CInput, CButton, CalendarColorField, CalendarFieldTitle }
}

})